import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';

@Component({
  selector: 'app-marketing-article-page',
  templateUrl: './marketing-article-page.component.html',
  styleUrls: ['./marketing-article-page.component.scss'],
})
export class MarketingArticlePageComponent implements OnInit {
  id: number = 0;
  constructor(
    private api: MarketingApiService,
    private route: ActivatedRoute
  ) {
    this.id = parseInt(this.route.snapshot.paramMap.get('id') || '0');
  }

  ngOnInit(): void {
    if (this.id) {
      this.getMarketingArticle();
    }
  }

  data: any;
  loading = false;
  async getMarketingArticle() {
    try {
      this.loading = true;
      const r = await this.api.getMarketingArticle(this.id);
      this.data = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
